import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowUndoUp: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconArrowUndoUp"><Path d="M5.41452 8L8.41436 5.00015L7.00015 3.58594L1.58594 9.00015L7.00015 14.4144L8.41436 13.0002L5.41421 10H20V17H11V19H22V8H5.41452Z" fill="currentColor"/></CentralIconBase>;
});

export default IconArrowUndoUp;
